import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { LoginPageContext } from "./LoginPageContext";

export const useLoginPage = () => {
  const context = useContext(LoginPageContext);

  if (!context) {
    throw new HookOutOfContextError("useLoginPage", "LoginPageContext");
  }

  return context;
};
